export const activityMockData = [
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 0,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },

  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
  {
    id: "6457589",
    name: "Twenty One Pilots: The Clancy World Tour",
    description:
      "Join the sensational Twenty One Pilots on their Clancy World Tour, an unforgettable musical journey.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_5.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "2h 30min",
    price: {
      amount: 75,
      currencyCode: "USD",
    },
  },
  {
    id: "6457590",
    name: "Missy Elliott: OUT OF THIS WORLD – THE EXPERIENCE",
    description:
      "Experience the magic of Missy Elliott live in concert, featuring her greatest hits and mesmerizing performances.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_concert_50.jpg"],
    geoCode: {
      latitude: 43.6434661,
      longitude: -79.3790989,
    },
    minimumDuration: "1h 45min",
    price: {
      amount: 95,
      currencyCode: "USD",
    },
  },
  {
    id: "6457591",
    name: "Toronto Operetta Theatre: El huesped del sevillano",
    description:
      "Ticket listings for Toronto Operetta Theatre: El huesped del sevillano at Jane Mallett Theatre in Toronto, Ontario on 05/03/2024.",
    pictures: ["https://cdn.smartvel.com/ccpictures/taxonomy/img_theater_16.jpg"],
    geoCode: {
      latitude: 43.6470384,
      longitude: -79.3754585,
    },
    minimumDuration: "2h 15min",
    price: {
      amount: 65,
      currencyCode: "USD",
    },
  },
];

export const activityPriceMockData = [
  { price: { amount: 55 }, minimumDuration: "1hr 30m", rating: 8.5, reviews: 123 },
  { price: { amount: 75 }, minimumDuration: "2hr 30m", rating: 9.3, reviews: 98 },
  { price: { amount: 60 }, minimumDuration: "2hr", rating: 9.0, reviews: 154 },
  { price: { amount: 42 }, minimumDuration: "1hr", rating: 9.7, reviews: 45 },
  { price: { amount: 95 }, minimumDuration: "3hr 30m", rating: 9.5, reviews: 201 },
  { price: { amount: 39 }, minimumDuration: "50m", rating: 8.9, reviews: 38 },
  { price: { amount: 65 }, minimumDuration: "2hr 45m", rating: 8.0, reviews: 124 },
  { price: { amount: 57 }, minimumDuration: "1hr 20m", rating: 8.6, reviews: 175 },
  { price: { amount: 30 }, minimumDuration: "40m", rating: 8.2, reviews: 80 },
  { price: { amount: 46 }, minimumDuration: "1hr 20m", rating: 7.8, reviews: 96 },
  { price: { amount: 58 }, minimumDuration: "2hr 30m", rating: 8.5, reviews: 135 },
  { price: { amount: 33 }, minimumDuration: "1hr 45m", rating: 8.9, reviews: 107 },
  { price: { amount: 56 }, minimumDuration: "1hr 40m", rating: 9.2, reviews: 169 },
  { price: { amount: 29 }, minimumDuration: "40m", rating: 9.6, reviews: 23 },
  { price: { amount: 37 }, minimumDuration: "1hr 10m", rating: 9.4, reviews: 85 },
];
